import React from 'react'
import Customer from './(content)/customer';
import TechnicalUnit from './(content)/technical-unit';
import SpareParts from './(content)/spare-parts';
import OptionalData from './(content)/optional-data';
import Description from './(content)/description';
import Checklist from './(content)/checklist';
import EndIntervention from './(content)/end-intervention';
import History from './(content)/history';

type Props = {
    active_tab?: string;
}

const Content = ({active_tab}:Props) => {
  return (
    <div className='flex-1 p-4 max-w-[calc(100dvw)] sm:max-w-[calc(100dvw-200px)]'>
        {active_tab === 'customer' && <Customer />}
        {active_tab === 'technical-unit' && <TechnicalUnit />}
        {active_tab === 'spare-parts' && <SpareParts />}
        {active_tab === 'optional-data' && <OptionalData />}
        {active_tab === 'description' && <Description />}
        {active_tab === 'checklist' && <Checklist />}
        {active_tab === 'end-intervention' && <EndIntervention />}
        {active_tab === 'history' && <History />}
    </div>
  )
}

export default Content